import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('../views/result'),
  },
  {
    path: '/agreeMent',
    name: 'agreeMent',
    component: () => import('../views/agreeMent'),
    meta: {
      title: '协议',
    },
  }
]

const router = new VueRouter({
  routes,
})

export default router
